<template>
  <div class="uploadImg">
      <!-- :on-change="uploadFile" -->
      <!-- <el-upload
        :limit="limit"  
        action
        accept="image/*" 
        :on-change="uploadFile"
        list-type="picture-card" 
        :auto-upload="false" 
        :file-list="fileList"
        :on-exceed="handleExceed"
        :on-preview="handlePictureCardPreview" 
        :on-remove="handleRemove"
        ref="upload"
        class="avatar-uploader"
        :class="{hide:showUpload}" 
        :disabled="disabled" 
      >
        <i class="el-icon-plus"></i>
      </el-upload> -->
      <!-- 图片 -->
      <el-upload
        v-if="acceptStr == '.jpg,.jpeg,.png,.JPG,.JPEG'"
        :limit="limit"  
        :action="url"
        :accept="acceptStr" 
        list-type="picture-card" 
        :file-list="fileList"
        :before-upload="beforeUploadHandle" :on-success="licensePathsuccessHandle"
        :on-exceed="handleExceed"
        :on-preview="handlePictureCardPreview" 
        :on-remove="handleRemove"
        ref="upload"
        class="avatar-uploader"
        :class="{hide:showUpload}" 
        :disabled="disabled" 
      >
        <i class="el-icon-plus"></i>
      </el-upload>
      <!-- 文档 -->
      <el-upload
        v-else
        :limit="limit"  
        :action="url"
        :accept="acceptStr" 
        list-type="text" 
        :file-list="fileList"
        :before-upload="beforeUploadHandle" :on-success="licensePathsuccessHandle"
        :on-exceed="handleExceed"
        :on-remove="handleRemove"
        :on-preview="handlePictureCardPreview1"
        ref="uploadFile"
        :class="{hide:showUpload}" 
        :disabled="disabled" 
      >
      <!-- :on-preview="handlePictureCardPreview"  -->

      <el-button size="small" type="primary" :disabled="disabled" @click="submitUpload">点击上传</el-button>
      </el-upload>
      <el-dialog width="30%" :visible.sync="dialogVisible">
        <img width="100%" :src="imgUrl.url" alt />
      </el-dialog>
      <!-- <Button text="上 传" type="add_u" style="margin-top: 10px;" @click.native="submitUpload"></Button> -->
      <el-image class="img-file" ref="image" :src="fileSrc" :preview-src-list="[fileSrc]" style="display:none;"></el-image>
  </div>
</template>

<script>
//引入上传图片接口
//   import { uploadImg } from "@/api/public/api";
import Cookies from 'js-cookie'

export default {
  props: {
    limit: Number,
    fileList: Array,
    disabled: Boolean,
    acceptStr:{
      type:String,
      default:'.jpg,.jpeg,.png,.JPG,.JPEG'
    }
  },
  data() {
    return {
      fileSrc:'',
      url:`${window.SITE_CONFIG['apiURL']}/oss/file/upload2?access_token=${Cookies.get('access_token')}`,
      showUpload: false, //控制limit最大值之后 关闭上传按钮
      dialogVisible: false, //查看图片弹出框
      imgUrl: [], //上传图片后地址合集
    };
  },
  //监听上传图片的数组(为了处理修改时,自动渲染问题,和上传按钮消失问题);
  watch: {
    fileList(newName, oldName) {
      if (newName.length == this.limit) this.showUpload = true;
      else this.showUpload = false;
    },
  },
  methods: {
    licensePathsuccessHandle (data, file) {
      if (data.code === 0) {
          this.$message.success("上传成功");
          this.fileList.push({...data.data,name:data.data.fileName});
          //调用父组件的方法来传递图片参数
          this.$emit("getUrl", this.fileList);
      } else this.$message.error("上传失败");
    },
    // 上传之前
  beforeUploadHandle (file) {
    console.log(file)
    // if (file.type !== 'image/jpg' && file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/gif') {
    // 	this.$message.error(this.$t('upload.tip', {
    // 		'format': 'jpg、png、gif'
    // 	}))
    // 	return false
    // }
    if (file.size / 1024 / 1024 > 30) {
      this.$message.error('文件太大，只能上传30MB以内的文件')
      return false
    }
  },
    //文件列表移除文件时的函数
    handleRemove(file, fileList) {
      console.log(file)
      console.log(fileList)
      const index = this.fileList.findIndex((item) => item === file.url);
      this.imgUrl.splice(index, 1);
      this.$emit("delUrl", fileList);
      if (fileList.length < this.limit) this.showUpload = false;
    },
    //点击文件列表中已上传的文件时的函数
    handlePictureCardPreview(file) {
      this.imgUrl.url = file.url;
      this.fileSrc =file.url;
      this.$nextTick(()=>{ //此处避免首次点击图片无法预览
        this.$refs["image"].clickHandler();
      })
      // this.dialogVisible = true;
    },
    handlePictureCardPreview1(file) {
      window.open(file.url)
    },
    //这里是不需要直接上传而是通过按钮上传的方法
    submitUpload() {
      this.$refs.uploadFile.submit();
    },
    //文件状态改变时的函数(主要逻辑函数)
    uploadFile(e, fileList) {
      //判断用户上传最大数量限制,来让上传按钮消失
      if (fileList.length >= this.limit) this.showUpload = true;
      // const file = e.file; <- 这里是不需要直接上传而是通过按钮上传的
      const file = e.raw; // <- 这里是直接上传的
      //大小
      const size = file.size / 1024 / 1024 / 50;
      if (
        !(
          file.type === "image/png" ||
          file.type === "image/gif" ||
          file.type === "image/jpg" ||
          file.type === "image/jpeg"
        )
      ) {
        this.$notify.warning({
          title: "警告",
          message:
            "请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片",
        });
      } else if (size > 50) {
        this.$notify.warning({
          title: "警告",
          message: "图片大小必须小于50M",
        });
      } else {
        if (this.limit == 1) this.imgUrl = []; //此处判断为一张的时候需要清空数组
        const params = new FormData();
        params.append("file", file);
        this.$http.post(`${window.SITE_CONFIG['apiURL']}/oss/file/upload2?access_token=${Cookies.get('access_token')}`,params,{headers: {'Content-Type': 'multipart/form-data'}}).then((res) => {
          if (res.data.code === 0) {
            this.$message.success("上传成功");
            this.fileList.push(res.data.data);
            //调用父组件的方法来传递图片参数
            this.$emit("getUrl", this.fileList);
          } else this.$message.error("上传失败");
        })
      }
    },
    //文件超出个数限制时的函数
    handleExceed(files, fileList) {
      this.$message.info(`最多只允许上传${this.limit}张附件`);
    },
  },
};
</script>

<style  scope lang="scss">
.uploadImg{
  display:flex;
  align-items:center;
  flex:1;
  flex-wrap:wrap;
  .avatar-uploader{
      width:100%;
      display:flex;
      align-items:center;
      .el-upload-list{
          display:flex !important;
          align-items:center;
          flex-wrap:wrap;
          flex:none;
          .el-upload-list__item:first-child{
              margin-top:0 !important;
          }
      }
  }
  .el-upload-list__item{
      flex:1;
  }
  .hide .el-upload--picture-card {
      display: none !important;
  }
  .avatar-uploader > .el-upload {
      width: 100px;
      height: 100px;
      line-height: 100px;
      border-radius: 0px;
      background: #fff;
      border: 1px dashed #ccc;
  }
  .avatar-uploader > .el-upload > i {
      font-size: 28px;
      color: #ccc;
  }
  .avatar-uploader > .el-upload-list {
      display: block;
  }
  .avatar-uploader > .el-upload-list > .el-upload-list__item {
      width: 100px;
      height: 100px;
      display: block;
  }
  .avatar-uploader > .el-upload-list > .el-upload-list__item > img {
      width: 100px;
      height: 100px;
      border-radius: 0px;
  }
}

</style>
